import { Component, OnInit } from '@angular/core';
import * as firebase from "firebase";
import { UserService } from '../../_services/user.service';
import { MatDialog } from '@angular/material';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Http } from '@angular/http';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})

export class ChangePasswordComponent implements OnInit {
  updateModel: any = {};
  userId = this.userService.getUid();
  user: any;
  providerArray: any[] = [];
  isEmail: boolean = true;
  ipAddress: any;
  loading: boolean;
  private subscription: Subscription = new Subscription();
  constructor(private dialog: MatDialog,
    private router: Router,
    private _http: Http,
    private userService: UserService) {
    firebase.auth().onAuthStateChanged(user => {
      this.user = user;
      if (user) {
        this.providerArray = this.user.providerData.filter(data => {
          return data.providerId == 'password';
        });
      }
    });
  }
  getIpAdress() {
    this.subscription.add(this._http.get("https://api.bigadvice.com/helper/ip")
      .map(data => { this.ipAddress = data.json() }).subscribe());
  }


  onSubmit() {
    this.loading = true;
    if (firebase.auth().currentUser) {
      const credentials = firebase.auth.EmailAuthProvider.credential(
        firebase.auth().currentUser.email, this.updateModel.currentPassword)
      firebase.auth().currentUser.reauthenticateWithCredential(credentials)
        .then(() => {
          if (this.updateModel.newPassword == this.updateModel.newPasswordAgain) {
            firebase.auth().currentUser.updatePassword(this.updateModel.newPassword).then(data => {
              this.dialog.open(SaveMessageComponent, {
                width: '400px',
                data: {
                  message: "Değişiklikler kaydedildi!",
                  type: "route",
                  goTo: "/profile-update"
                }
              });
              this.userService.userLog('change-password', this.ipAddress)

              this.loading = false;
            }).catch((e) => {
              this.loading = false;
              this.dialog.open(SaveMessageComponent, {
                width: '400px',
                data: {
                  message: "Hesabının güvenliği için seni doğrulamamız gerekiyor. Lütfen tekrar giriş yap!",
                  type: "update",
                  info: "cahngePassword"
                }
              });
            });

          } else {
            this.dialog.open(SaveMessageComponent, {
              width: '400px',
              data: {
                message: "Yeni Şifrelerin Uyuşmuyor!",
                type: "update"
              }
            });
            this.loading = false;
          }
        },
          (error) => {
            this.dialog.open(SaveMessageComponent, {
              width: '400px',
              data: {
                message: "Eski Şifren Yanlış!",
                type: "update"
              }
            });
            this.loading = false;
          });
    } else {
      this.router.navigate(["auth"], { queryParams: { returnUrl: "profile-update/change-password", type: "login" } })
    }

  }

  onSubmitOther(form) {
    if (!this.updateModel.newPassword || !this.updateModel.newPasswordAgain) {
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: "Geçerli bir şifre girmelisin.",
          type: "update"
        }
      });
      return;
    }
    this.loading = true;
    if (this.updateModel.newPassword == this.updateModel.newPasswordAgain) {
      try {
        firebase.auth().currentUser.updatePassword(this.updateModel.newPassword).then(data => {
          this.dialog.open(SaveMessageComponent, {
            width: '400px',
            data: {
              message: "Değişiklikler kaydedildi!",
              type: "route",
              goTo: "/profile-update"
            }
          });
          this.loading = false;
        }).catch((e) => {
          this.loading = false;
          this.dialog.open(SaveMessageComponent, {
            width: '400px',
            data: {
              message: "Hesabının güvenliği için seni doğrulamamız gerekiyor. Lütfen tekrar giriş yap!",
              type: "update",
              info: "cahngePassword"
            }
          });
        });
      } catch (e) {
      }
    } else {
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: "Yeni şifrelerin uyuşmuyor.",
          type: "update"
        }
      });
      this.loading = false;
    }
  }

  ngOnInit() {
    this.getIpAdress();

  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/profile-update/change-password/change-password.component.ts